<template>
  <RadioGroup>
    <Radio
      :id="`ua-${name}`"
      :name="`gaVersion-${name}`"
      value="ua"
      :checked="checked"
      :disabled="disabled"
      @change="change"
      ><p>ユニバーサルアナリティクス（UAデータ表示）</p></Radio
    >
    <Radio
      :id="`ga4-${name}`"
      :name="`gaVersion-${name}`"
      value="ga4"
      :checked="checked"
      :disabled="disabled"
      @change="change"
    >
      <p>Googleアナリティクス4（GA4データ表示）</p>
    </Radio>
  </RadioGroup>
</template>
<script>
import Radio from '@/components/Radio';
import RadioGroup from '@/components/RadioGroup';

export default {
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    checked: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false
    }
  },
  components: {
    Radio,
    RadioGroup
  },
  methods: {
    change(checked) {
      this.$emit('change', checked);
    }
  }
};
</script>
